import {Injectable} from '@angular/core';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {EntityAccountListDto} from '@dto/holdings/entity-account-list.dto';
import {EntityAccountDto} from '@dto/holdings/entity-account.dto';
import {EntityAccountViewModel} from '../view-models/entity-account.view-model';

@Injectable({
  providedIn: 'root'
})
export class EntityAccountConverterService {

  public convert(entityCode: string, entityAccountList: EntityAccountListDto): EntityAccountViewModel[] {
    return entityAccountList.entityAccounts.map(entityAccount => this.convertSingle(entityCode, entityAccount));
  }

  private convertSingle(entityCode: string, entityAccount: EntityAccountDto): EntityAccountViewModel {
    return {
      entityCode: entityCode,
      id: entityAccount.id,
      portfolioNumber: entityAccount.portfolioNumber,
      name: entityAccount.name,
      number: entityAccount.number,
      currency: entityAccount.currency,
      balance: new FormattedNumber(entityAccount.balance),
    };
  }
}
